"use client";

import { useEffect, useState } from "react";
import { TickerItem } from "@/components/landing/ticker-item";
import type { StartupRecord } from "@/lib/types";

const REFRESH_INTERVAL_MS = 60_000;

type Props = {
  slug: string;
  initialData: StartupRecord;
  onClear: () => void;
};

export function SelectedStartupTicker({ slug, initialData, onClear }: Props) {
  const [startup, setStartup] = useState<StartupRecord>(initialData);

  useEffect(() => {
    async function fetchLive() {
      try {
        const res = await fetch(`/api/startups/${encodeURIComponent(slug)}`, {
          cache: "no-store"
        });
        if (!res.ok) return;
        const json = await res.json();
        const data = json.data as StartupRecord;
        if (data) setStartup(data);
      } catch {
        // Keep existing data on error
      }
    }

    fetchLive();
    const interval = setInterval(fetchLive, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [slug]);

  return (
    <TickerItem startup={startup} showClear onClear={onClear} />
  );
}
